var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 17,
    height: 14.878,
    fill: "#a0a0a0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signature",
    transform: "translate(-713 -622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528",
    transform: "translate(713 623.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M0,25.3a6.007,6.007,0,0,1,.316-.988,2.743,2.743,0,0,1,2.426-1.565c.5-.026,1.007-.01,1.511-.006a.712.712,0,1,1,.019,1.423c-.448.01-.9,0-1.345,0a1.422,1.422,0,0,0-.252,2.83c.148.015.3.023.447.023l11.722,0a1.343,1.343,0,0,1,.36.037.7.7,0,0,1,.5.706.709.709,0,0,1-.577.661,1.373,1.373,0,0,1-.247.021q-5.969,0-11.938,0A2.849,2.849,0,0,1,.155,26.5c-.069-.2-.1-.4-.155-.606v-.6",
    transform: "translate(0 -13.568)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M17.625,10.595c-.315,0-.631.006-.946,0a.679.679,0,0,1-.726-.667,21.288,21.288,0,0,1,.04-2.17A3.488,3.488,0,0,1,17.1,5.568Q18.37,4.3,19.637,3.033c.78-.778,1.537-1.579,2.349-2.321a2.55,2.55,0,0,1,2.8-.5,2.582,2.582,0,0,1,1.7,2.171,2.611,2.611,0,0,1-.778,2.3q-2.392,2.409-4.8,4.8a3.736,3.736,0,0,1-2.72,1.111c-.188,0-.376,0-.564,0m5.432-5.272L21.2,3.466a1.407,1.407,0,0,1-.1.127c-.966.967-1.911,1.955-2.905,2.893a3.008,3.008,0,0,0-.8,2.682c.246,0,.493,0,.74,0A2.433,2.433,0,0,0,19.982,8.4c.756-.77,1.524-1.528,2.287-2.291l.788-.786M24.1,4.285a8.707,8.707,0,0,0,.746-.8A1.231,1.231,0,0,0,24.9,2.061a1.317,1.317,0,0,0-1.238-.61c-.663.066-.977.6-1.4.983L24.1,4.285",
    transform: "translate(-9.517 0)",
    fill: "#a0a0a0"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    width: 17,
    height: 17,
    transform: "translate(713 622)",
    fill: "none",
    opacity: 0.17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/signature_icon.383c1ed9283779dec9ede2b3d2149730.svg";
export { ForwardRef as ReactComponent };